import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/VersionView02.vue')
  },
  {
    path: '/version-01-light',
    name: 'version01Light',
    component: () => import('../views/VersionView01.vue'),
    props: { styleModeActive: 'sun' }
  },
  {
    path: '/version-01-dark',
    name: 'version01Dark',
    component: () => import('../views/VersionView01.vue'),
    props: { styleModeActive: 'moon' }
  },
  {
    path: '/:pathMatch(.*)',
    component: () => import('../views/VersionView02.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
